import React from 'react';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import { withStyles } from "@material-ui/core/styles";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { AiFillInfoCircle } from 'react-icons/ai';
import { Card, CardContent, Typography, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, CircularProgress, Divider, ListItemText, Popper, Button, TextField, FormControlLabel, Radio } from '@material-ui/core';
import ReactSelect from 'react-select';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar } from 'recharts';
import { DateRangePicker } from 'rsuite';
import { addDays, endOfDay, getUnixTime, startOfDay, subDays } from 'date-fns';
import outgoing from '../../../assets/icons/outgoingcalls.png';
import incoming from '../../../assets/icons/incomingcalls.png';
import axiosInstance from '../../../environment/axiosInstance'
import Reports from '../../History/Reports/Reports';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import sortDown from '../../../assets/images/Sort Down.png'
import CallCountBreakdown from './CallCountBreakdown/CallCountBreakdown';
import Cbreakdown from './ccbkd/Callbrakdown';
import CallingHabits from './CallingHabits/CallingHabits';
import { useStyles } from './style';
import './styles.css';
import LeaderBoards from './LeaderBoards/LeaderBoards';
import Select from '@mui/material/Select';
import TableBodyData from './LeaderBoards/TableBodyData';
import AllCalls from './AllCalls/AllCalls';




const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'rgb(77, 114, 248);',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5'
  },
})((props: any) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));


function Analytics(props: any) {
  const classes = useStyles()
  const history = useHistory()
  const [loading, setLoading] = React.useState<any>(false)
  const [defaultDates, setDefaultDates] = React.useState('')
  const [endDates, setendDates] = React.useState('')
  const [chartDataa, setChartDataa] = React.useState([])
  const [AllcallschartDataa, setAllcallschartDataa] = React.useState([])
  const [anchorEll, setAnchorEll] = React.useState<any>(null);
  const [groupUserData, setGroupUserData] = React.useState<any>({});
  const [userOfficeSelected, setUserOfficeSelected] = React.useState<any>('Select');
  const [anchorEldt, setAnchorEldt] = React.useState<any>(null);
  const [startDate, setstartDate] = React.useState<any>()
  const [endDate, setendDate] = React.useState<any>()
  const [selectOffice, setselectOffice] = React.useState<any>('HELLO')
  const [searchData, setSearchData] = React.useState('')
  const [getData, setGetData] = React.useState('')
  const [callFormData, setCallFormData] = React.useState<any>({
    statusKey: "",
    callStatus: "",
    startDate: new Date().setHours(0, 0, 0, 0),
    callFromDateData: "startDate",
    endDate: new Date().setHours(23, 59, 59, 59),
    remainderDateData: "endDate"
  })

  const handleClickAway = () => {
    setAnchorEldt(null)
    setAnchorEll(null)
  }


  const officesData: any = [
    {
      value: 1, label: "department1"
    },
    {
      value: 2, label: "department2"
    },
    {
      value: 3, label: "department3"
    }
  ]

  const dailyData: any = [
    {
      value: 1, label: "Custom"
    },
    {
      value: 2, label: "Today"
    },
    {
      value: 3, label: "Yesterday"
    },
    {
      value: 3, label: "Last week"
    },
    {
      value: 3, label: "Last Month"
    },
    {
      value: 3, label: "Past 7 Days"
    }
    ,
    {
      value: 3, label: "Past 30 Days"
    }

  ]

  const urlPath = props.location.search

  const departmentStateData = useSelector((state: any) => state.departmentModule);
  const { selectedCompany } = departmentStateData;
  const officeId = localStorage.getItem('SelectedCompanyId')
  const chartData = () => {
    let url = `/dashboard/analytics-graph`
    if (officeId) {
      //url = `/dashboard/analytics-graph?officeId=${officeId}`
    }
    if (props.location.search) {
      url = `/dashboard/analytics-graph${props.location.search}`;
    }
    axiosInstance.get(url).then((res: any) => {
      if (res.status === 200) {
        const data = res.data.data
        setChartDataa(data)
      }
    })
  }
  // GRAPH
  const allCallsChartData = () => {
    let url = `/dashboard/new-analytics-graph`
    if (props.location.search) {
      url = `/dashboard/new-analytics-graph${props.location.search}`;
    }
    if (officeId) {
      url = `/dashboard/new-analytics-graph?officeId=${officeId}`
    }
    axiosInstance.get(url).then((res: any) => {
      if (res.status === 200) {
        const data = res.data.data
        setAllcallschartDataa(data)
      }
    })
  }

  //all users data
  const allUsersData = () => {
    axiosInstance.get('dashboard/teams-departments-companies').then((res: any) => {
      if (res.status === 200) {
        setGroupUserData(res.data.Data);
      }
    }).catch((err: any) => {

    })
  }
  


  const handleClickNextPage = () => {
    let queryFilter: any = '';
    console.log('searchData', searchData);
    if (searchData) {
      let userD = searchData.split('_');
      // console.log('userD', userD);
      queryFilter = userD[0] + '=' + userD[1] + '&'

      if (userD[0] == 'userId') {
        let teams = groupUserData.Teams;
        let userD1 = teams.find((value: any) => {
          if (value._id == userD[1]) {
            return true
          }
        })
        setUserOfficeSelected(userD1.email);
      }
      //offices
      if (userD[0] == 'officeId') {
        let companies = groupUserData.companies;
        let userD1 = companies.find((value: any) => {
          if (value._id == userD[1]) {
            return true
          }
        })
        setUserOfficeSelected(userD1.name);
      }
      //roomphones
      if (userD[0] == 'roomPhoneId') {
        let roomPhones = groupUserData.roomPhones;
        let userD1 = roomPhones.find((value: any) => {
          if (value._id == userD[1]) {
            return true
          }
        })
        setUserOfficeSelected(userD1.name);
      }
      // Departments
      if (userD[0] == 'departmentId') {
        let deptDetails = groupUserData.Departments;
        let userD1 = deptDetails.find((value: any) => {
          if (value._id == userD[1]) {
            return true
          }
        })
        setUserOfficeSelected(userD1.name);
      }
    }

  
    if (callFormData.startDate && callFormData.endDate) {
      queryFilter += `startDate=${callFormData.startDate}&endDate=${callFormData.endDate}`;
    }
    history.push(`/dashboard/analytics?${queryFilter}`)


    //startdate && endDate
    // let datesss: any = queryFilter.split("=");
    // // console.log('datesss', datesss[1].split('&'));
    
    // setDefaultDates(datesss)
    // const end = datesss[1].split('=')
    // const endDate = end[0].split("&")
    // setendDates(endDate)
  }



  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEll(anchorEll ? null : event.currentTarget);
    setAnchorEldt(null)
    setstartDate('')
    setendDate('')
  };
  const handleClickdt = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEldt(anchorEldt ? null : event.currentTarget);
    setAnchorEll(null)
    setselectOffice('')
  };
  const open = Boolean(anchorEll);
  const id = open ? "department-popper" : undefined;

  const opendt = Boolean(anchorEldt);
  const iddt = open ? "date-popper" : undefined;
  React.useEffect(() => {
    fetchCallbreakdownData()
    allCallsChartData()
    fetchAgentsCallData()
  }, [props.location.search])

  React.useEffect(() => {
    allUsersData()
  }, [])

  const displayDates = (dateString: any) => {
    const dateNow = new Date(dateString);
    const year = dateNow.getFullYear();
    const monthWithOffset = dateNow.getMonth() + 1;
    const month = monthWithOffset.toString().length < 2 ? `0${monthWithOffset}` : monthWithOffset;
    const date = dateNow.getDate().toString().length < 2 ? `0${dateNow.getDate()}` : dateNow.getDate();
    const materialDateInput = `${year}-${month}-${date}`;
    return materialDateInput
  }

  //date range selector

  const globalUsers = (e: any) => {
    setSearchData(e.target.value);
  }



  const handleDateRange = (e: any) => {
    console.log('e', e)
    const startDt = e[0]
    const endDt = e[1]
    setCallFormData((prev: any) => {
      return {
        ...prev,
        startDate: getUnixTime(startDt).toString(),
        endDate: getUnixTime(endDt).toString()
      }
    })
    // setCallFormData(getUnixTime(startDt).toString())
    // setCallFormData(getUnixTime(endDt).toString())
    console.log('hhh', getUnixTime(startDt), getUnixTime(endDt))
  }

  const Ranges: any = [
    {
      label: 'today',
      value: [startOfDay(new Date()), endOfDay(new Date())]
    },
    {
      label: 'yesterday',
      value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))]
    },
    {
      label: 'last7Days',
      value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())]
    },
    {
      label: 'last30Days',
      value: [startOfDay(subDays(new Date(), 29)), endOfDay(new Date())]
    }
  ];

  // console.log('Ranges', Ranges);


  const handleSelectedOffc = (e: any) => {
    setselectOffice(e.value)
  }
  const [data, setData] = React.useState<any>();

  // call break down
  const fetchCallbreakdownData = async () => {
    let url = `/dashboard/call-count-breakdown`
    if (officeId) {
      url = `/dashboard/call-count-breakdown?officeId=${officeId}`
    }
    if (selectOffice) {
      url += `?companyId=${selectOffice}`
    }
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`
    }
    if (props.location.search) {
      url = `/dashboard/call-count-breakdown${props.location.search}`;
    }
    await axiosInstance.get(url).then((res: any) => {
      if (res.data.data) {
        setAnchorEldt(null)
        setAnchorEll(null)
        setData(res.data.data)
      }

    }).catch((err: any) => {

    })
  }




  //leaderboards
  const [agentsData, setAgentsData] = React.useState<any>([])
  const fetchAgentsCallData = () => {
    setLoading(true)
    let url = `/dashboard/agent-calls`
    if (officeId) {
      url = `/dashboard/agent-calls?officeId=${officeId}`
    }
    if (props.location.search) {
      url = `/dashboard/agent-calls${props.location.search}`;
    }
    axiosInstance.get(url).then((res: any) => {
      if (res.status === 200) {
        setLoading(false)
        setAgentsData(res.data.data)
      }
    }).catch((err: any) => {
      setLoading(false)
    })
  }



  function toTime(d: any) {
    d = Number(d);

    var h = (Math.floor(d / 3600)).toString().length > 1 ? Math.floor(d / 3600) : '0' + Math.floor(d / 3600);
    var m = (Math.floor(d % 3600 / 60)).toString().length > 1 ? Math.floor(d % 3600 / 60) : '0' + Math.floor(d % 3600 / 60);
    var s = (Math.floor(d % 3600 % 60)).toString().length > 1 ? Math.floor(d % 3600 % 60) : '0' + Math.floor(d % 3600 % 60);
    return h + ":" + m + ":" + s
  }

  const handleClickUsers = (item: any) => {
    console.log('item',item)
    let url = "";
    if (item.userType === "1") {
      url += `/dashboard/allreports?userId=${item._id}`
    } else {
      url += `/dashboard/allreports?roomPhoneId=${item._id}`
    }
    window.open(url, "_blank")
  }

  return (
    <div>
      <Card className={classes.card} style={{ padding: 20 }}>
        <div>
          <h1 className='headerStyle'>All Calls</h1>
          <Typography>Explore what's happening on calls with</Typography>
        </div>
        <ClickAwayListener onClickAway={handleClickAway}>
          <div style={{ display: 'flex' }}>
            <div>
              <Button variant='contained' aria-describedby={id} onClick={handleClick}
                style={{ marginTop: "10px", marginRight: '15px', backgroundColor: '#ffffff' }} endIcon={<img src={sortDown} alt="company select" />}>
                {
                  userOfficeSelected
                }
              </Button>
              <Popper id={id} open={open} anchorEl={anchorEll} placement={'bottom-start'} >
                <Box sx={{
                  border: "1px solid blueviolet", p: 2, bgcolor: "background.paper", width: "330px", height: "180px",
                  borderRadius: "8px"
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 15 }}>
                    <Typography className={classes.usersorgroups}>Users or Groups</Typography>
                    <AiFillInfoCircle />
                  </div>
                  <Select
                    size='small'
                    onChange={globalUsers}
                    native
                    defaultValue={searchData} 
                    id="grouped-native-select"
                    label="Grouping"
                  >
                    <option aria-label="User & Offices" value="" />
                    <optgroup label="Users">
                      {
                        groupUserData.Teams?.map((item: any) => {
                          return <option value={'userId_' + item._id}>{item.email}</option>
                        })
                      }
                    </optgroup>
                    <optgroup label="Departments">
                      {
                        groupUserData.Departments?.map((item: any) => {
                          return <option value={'departmentId_' + item._id}>{item.name}</option>
                        })
                      }
                    </optgroup>
                    <optgroup label="Offices">
                      {
                        groupUserData.companies?.map((item: any) => {
                          return <option value={'officeId_' + item._id}>{item.name}</option>
                        })
                      }
                    </optgroup>
                    <optgroup label="Room Phones">
                      {
                        groupUserData.roomPhones?.map((item: any) => {
                          return <option value={'roomPhoneId_' + item._id}>{item.name}</option>
                        })
                      }
                    </optgroup>
                  </Select>
                  <div style={{ display: 'flex', alignItems: 'flex-end', width: '100%' }}>
                    <Button variant='outlined'
                      style={{ marginTop: "10px", marginRight: '10px' }} onClick={handleClickNextPage}>
                      Apply
                    </Button>
                  </div>
                </Box>
              </Popper>
            </div>
            <div>
              <Button style={{ marginTop: "10px", backgroundColor: '#ffffff', textTransform: 'capitalize' }} variant='contained' aria-describedby={iddt}
                endIcon={<img src={sortDown} alt="company select" />} onClick={handleClickdt}>
                {defaultDates[0] ? defaultDates[0] : "Select dates"} {endDates[1] ? endDates[1] : ''}
              </Button>
              <Popper id={iddt} open={opendt} anchorEl={anchorEldt} placement={'bottom-start'} >
                <Box sx={{
                  border: "1px solid blueviolet", p: 1, bgcolor: "background.paper", width: "330px",
                  borderRadius: "8px"
                }}>
                  <Divider className={classes.divider} />
                  <div style={{ width: "100%" }}>
                    <Grid>
                      <DateRangePicker onChange={handleDateRange} placeholder="Select Date Range" ranges={Ranges} />
                    </Grid>
                    <Grid container xl={4} lg={12} md={12} sm={12} xs={12}>
                    </Grid>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%' }}>
                      <Button variant='contained'
                        style={{ marginTop: "10px", marginRight: '10px' }}
                        onClick={handleClickNextPage}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                </Box>
              </Popper>
            </div>
          </div>
        </ClickAwayListener>
      </Card>

      {/* <AllCalls
        handleClickNextPage={handleClickNextPage}
        groupUserData={groupUserData}
        handleDateRange={handleDateRange}
        handleClick={handleClick}
        handleClickAway={handleClickAway}
        globalUsers={globalUsers}
         handleClickdt={handleClickdt}
      /> */}

      {/* 
      <Grid container spacing={2} className={classes.grid}>
        <Grid item md={12} sm={12} xs={12} className={classes.select}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Grid container spacing={2}>
                <Grid item md={12} className={classes.cardContent}>
                  <img src={incoming} alt="incoming" />
                  <Typography className={classes.incomingText}>Total Calls</Typography>
                  <img src={outgoing} alt="outgoing" />
                  <Typography className={classes.outgoingText}>Answered Calls</Typography>

                </Grid>
              </Grid>
            </CardContent>
            <Typography className={classes.areaText}>Last 30 Days</Typography>
            <Grid container spacing={2} style={{ marginTop: 10 }}>
              <Grid item md={12} className={classes.gridItem}>
                <AreaChart width={1130} height={400} data={chartDataa}>
                  <XAxis
                    interval={0}
                    axisLine={false}
                    tickLine={false}
                    dataKey="lv"
                    padding={{ left: 20, right: 20 }}
                  />
                  <YAxis dataKey="sv" tickCount={7} axisLine={false} tickLine={false} />
                  <Tooltip />
                  <CartesianGrid vertical={false} strokeDasharray="3,3" />

                  <Area
                    type="monotone"
                    dataKey="answeredCalls"
                    stroke="gold"
                    fill="rgba(51, 108, 251, 0.2)"
                  />
                  <Area
                    type="monotone"
                    dataKey="totalCalls"
                    stroke="#4D72F8"
                    fill="rgba(51, 108, 251, 0.2)"
                  />
                </AreaChart>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid> */}
      <div style={{ marginTop: 20, borderRadius: 10, border: '3px solid grey', padding: 2 }}>
        <Grid style={{ marginBottom: 20 }}>
          <Card className={classes.card} style={{ paddingTop: 20 }}>
            <Typography className={classes.areaText}>Call Count Breakdown </Typography>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 951 }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ background: '#c9c9c9', width: '12px', height: '12px', borderRadius: '50%', marginRight: 10 }} > </div>
                <p > Total calls</p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ background: '#ab7eff', width: '12px', height: '12px', borderRadius: '50%', marginRight: 10 }} > </div>
                <p > Answered calls</p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ background: '#815df4', width: '12px', height: '12px', borderRadius: '50%', marginRight: 10 }} > </div>
                <p > Missed calls</p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ background: '#815df4', width: '12px', height: '12px', borderRadius: '50%', marginRight: 10 }} > </div>
                <p > Unanswered Transferred calls</p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ background: '#815df4', width: '12px', height: '12px', borderRadius: '50%', marginRight: 10 }} > </div>
                <p > Outbound (Connected)</p>
              </div>
              {/* <FormControlLabel value="other" control={<Radio size='small' checked />} label="Total calls" />
        <FormControlLabel value="other" control={<Radio checked style={{ color: '#ab7eff' }} />} label="Answered calls" />
        <FormControlLabel value="other" control={<Radio checked style={{ color: '#815df4' }} />} label="Missed calls" />
        <FormControlLabel value="other" control={<Radio checked style={{ color: '#815df4' }} />} label="Unanswered Transferred calls" />
        <FormControlLabel value="other" control={<Radio checked style={{ color: '#815df4' }} />} label="Outbound (Connected)" /> */}
            </div>
            <Cbreakdown calldata={data} urlPath={urlPath} />
          </Card>

        </Grid>
        {/* <Grid className={classes.gridItem} >
        <Card style={{ padding: 20 }}>
          <Typography className={classes.areaText}>Calling Habits</Typography>
          <CallingHabits />
        </Card>
      </Grid> */}

        {/* <div>
        <CallCountBreakdown />
      </div>  */}
        {/* <div>
        <h1 className={classes.usersorgroups}>Call Count Breakdown</h1>
        
      </div> */}

        <Grid container spacing={2} className={classes.grid}>
          <Grid item md={12} sm={12} xs={12} className={classes.select}>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                <Grid container spacing={2}>
                  <Grid item md={12} className={classes.cardContent}>
                    <img src={incoming} alt="incoming" />
                    <Typography className={classes.incomingText}>Total Calls</Typography>
                    <img src={outgoing} alt="outgoing" />
                    <Typography className={classes.outgoingText}>Answered Calls</Typography>

                  </Grid>
                </Grid>
              </CardContent>
              <Typography className={classes.areaText}>Call Volume Over Time</Typography>
              <Grid container spacing={2} style={{ marginTop: 10 }}>
                <Grid item md={12} className={classes.gridItem}>
                  <AreaChart width={1130} height={400} data={AllcallschartDataa}>
                    <XAxis
                      interval={0}
                      axisLine={false}
                      tickLine={false}
                      dataKey="lv"
                      padding={{ left: 20, right: 20 }}
                    />
                    <YAxis dataKey="sv" tickCount={10} axisLine={false} tickLine={false} />
                    <Tooltip />
                    <CartesianGrid vertical={false} strokeDasharray="3,3" />
                    <Area
                      type="natural"
                      dataKey="totalCalls"
                      stroke="green"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                    <Area
                      type="monotone"
                      dataKey="answeredCalls"
                      stroke="gold"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                    <Area
                      type="monotone"
                      dataKey="missedCalls"
                      stroke="#4D72F8"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                    <Area
                      type="monotone"
                      dataKey="abandonedCalls"
                      stroke="blue"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                    <Area
                      type="monotone"
                      dataKey="unansweredforwarded"
                      stroke="blueviolet"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                    <Area
                      type="monotone"
                      dataKey="outboundConnected"
                      stroke="gray"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                    <Area
                      type="monotone"
                      dataKey="outboundCancelled"
                      stroke="orange"
                      fill="rgba(51, 108, 251, 0.2)"
                    />
                  </AreaChart>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>


        <Card style={{ marginTop: 10 }} className={classes.card}>
          <div style={{ padding: 20 }}>
            <Typography className={classes.leaderBoards}>Leaderboards</Typography>
          </div>
          <Divider />
          {/* <LeaderBoards /> */}
          <div>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableCell className={classes.tCell}>User</TableCell>
                  <TableCell className={classes.tCell}>Calls</TableCell>
                  <TableCell className={classes.tCell}>Total Duration</TableCell>
                  <TableCell className={classes.tCell}>Avg Duration</TableCell>
                  <TableCell className={classes.tCell}>Answered</TableCell>
                  <TableCell className={classes.tCell}>Placed</TableCell>
                  <TableCell className={classes.tCell}>Missed</TableCell>
                  <TableCell className={classes.tCell}>Cancelled</TableCell>
                  <TableCell className={classes.tCell}>Abondoned</TableCell>
                </TableHead>
                <TableBody>
                  {loading ?
                    <Box>
                      <div style={{ position: "absolute", width: "100%", textAlign: "center" }}>
                        <CircularProgress />
                      </div>
                    </Box>
                    :
                    agentsData?.map((item: any) => {
                      return (
                        <TableRow>
                          <TableCell style={{ cursor: 'pointer' }} className={classes.tbody}
                            onClick={() => handleClickUsers(item)}
                          >{item.name}</TableCell>
                          <TableCell className={classes.tbody}>{item.totalCalls}</TableCell>
                          <TableCell className={classes.tbody}>{toTime(item.totalDuration)}</TableCell>
                          <TableCell className={classes.tbody}>{toTime(item.avgDuration)}</TableCell>
                          <TableCell className={classes.tbody}>{item.answered}</TableCell>
                          <TableCell className={classes.tbody}>{item.placed}</TableCell>
                          <TableCell className={classes.tbody}>{item.missed}</TableCell>
                          <TableCell className={classes.tbody}>{item.cancelled}</TableCell>
                          <TableCell className={classes.tbody}>{item.abondoned}</TableCell>
                        </TableRow>
                      )
                    }
                      // <TableBodyData
                      //   item={item}
                      //   agentsData={agentsData}
                      //   fetchAgentsCallData={fetchAgentsCallData}
                      //   searchData={searchData}
                      // />
                    )

                  }
                </TableBody>
              </Table>
              {
                agentsData <= 0 &&
                <p style={{ textAlign: 'center' }}>
                  No Data found
                </p>
              }
            </TableContainer>
          </div>


        </Card>
      </div>
    </div>
  )
}

export default Analytics